import { scoreType } from '@/components/10_FuturesKnowledge/types';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 期貨交易知識認知確認表
 */
const FuturesKnowledgeViewData = [
    'POST',
    RouteUrlList.API_FuturesKnowledgeViewData.path,
    {},
    200,
    {
        status: true,
        title: 'Success',
        message: 'Success',
        errorCode: '0000',
        result: {
            futuresKnowledgeObj: [
                {
                    index: 1,
                    question: '為增加盤前資訊透明度，臺灣期貨期交所於盤前委託時段揭露各契約模擬試撮之開盤價、量及試撮後之最佳5檔買賣價量資訊。',
                    answerList: [
                        { scoreType: scoreType.Correct, answer: '正確' },
                        { scoreType: scoreType.Incorrect, answer: '不正確' }
                    ],
                    answer: scoreType.Correct,
                    correctAnswer: scoreType.Correct,
                    correctAnswerResolve: '此題敘述正確。',
                    errorMsg: null
                },
                {
                    index: 2,
                    question: '交易人從事國內、國外期貨交易，其交易制度及風險控管機制會因各國交易所、複委託期貨商或我國期貨商規定而有不同。',
                    answerList: [
                        { scoreType: scoreType.Correct, answer: '正確' },
                        { scoreType: scoreType.Incorrect, answer: '不正確' }
                    ],
                    answer: scoreType.Correct,
                    correctAnswer: scoreType.Correct,
                    correctAnswerResolve: '此題敘述正確。',
                    errorMsg: null
                },
                {
                    index: 3,
                    question: '「一定範圍市價委託」是一種不需指定委託價格，但可將成交價格限制在一定範圍內，可降低成交價格大幅偏離交易人預期之情況。',
                    answerList: [
                        { scoreType: scoreType.Correct, answer: '正確' },
                        { scoreType: scoreType.Incorrect, answer: '不正確' }
                    ],
                    answer: scoreType.Correct,
                    correctAnswer: scoreType.Correct,
                    correctAnswerResolve: '此題敘述正確。',
                    errorMsg: null
                },
                {
                    index: 4,
                    question:
                        '價格穩定機制係避免價格異常波動的措施，國、內外期貨交易所之價格穩定機制或有不同，但都無法改變市場價格走勢，價格走勢不符預期的部位仍須注意風險控管。',
                    answerList: [
                        { scoreType: scoreType.Correct, answer: '正確' },
                        { scoreType: scoreType.Incorrect, answer: '不正確' }
                    ],
                    answer: scoreType.Correct,
                    correctAnswer: scoreType.Correct,
                    correctAnswerResolve: '此題敘述正確。',
                    errorMsg: null
                },
                {
                    index: 5,
                    question: '交易人以期貨商所提供之報價資訊為下單之唯一依據，不需進行其他驗證。',
                    answerList: [
                        { scoreType: scoreType.Correct, answer: '正確' },
                        { scoreType: scoreType.Incorrect, answer: '不正確' }
                    ],
                    answer: scoreType.Incorrect,
                    correctAnswer: scoreType.Incorrect,
                    correctAnswerResolve:
                        '交易人應瞭解期貨商所提供之報價資訊係由交易所或資訊廠商所提供，雖得自於一般認為可資信賴之來源，但不保證此等資訊之正確與完整，故交易前仍應自行查證。',
                    errorMsg: null
                }
            ]
        }
    }
];

export default FuturesKnowledgeViewData;
